export enum CMSEnum {
  HomeMiddleContent = 1,
  AboutUs = 2,
  ServiceTerms = 3,
  PrivacyPolicy = 4,
  FAQs = 5,
  BottomContent = 6,
  SocialMedia = 7,
  EezyRent = 8,
  HomeContent = 9
}